(function () {
  'use strict';

  angular.module('ringbaPortal').component('trPingTreeTarget', {
    bindings: {
      onSave: '&',
      onDismiss: '&',
      pingTreeTarget: '<',
      pingTreeTargetIdToClone: '@'
    },
    controller: PingTreeTargetController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/pingtreetargets/ping-tree-target.view.html'
  });

  function PingTreeTargetController(
    $state,
    $anchorScroll,
    accountsService,
    pingTreeTargetService,
    utils
  ) {

    const vm = this;
    vm.$onInit = onInit;
    vm.onSaveRtt = onSaveRtt;

    function onInit() {
      if (vm.pingTreeTarget) {
        _loadTarget(vm.pingTreeTarget.id);
      }
      else if (vm.pingTreeTargetIdToClone) {
        _loadAndCloneTarget(vm.pingTreeTargetIdToClone);
        vm.pingTreeTargetIdToClone = null;
      }
    }

    function onSaveRtt(event) {
      $anchorScroll();
      if (event.newPingTreeTarget || vm.pingTreeTargetIdToClone) {
        _changeURLByAddingId(event.pingTreeTarget.id);
      }
      vm.onSave(event);
    }

    function _changeURLByAddingId(pingTreeTargetId) {
      $state.go('dashboard.ringtreetarget.new', {
        pingTreeTargetId: pingTreeTargetId
      });
    }

    function _loadTarget(pingTreeTargetId) {
      pingTreeTargetService.getTarget(accountsService.currentAccountId, pingTreeTargetId)
        .then(function (response) {
          vm.currentPingTreeTarget = pingTreeTargetService.formatParsers(response.data.pingTreeTarget);
          vm.isRtbRTTResponse = response.data.isRtbRTTResponse;
        })
        .catch(utils.errorHandler);
    }

    function _loadAndCloneTarget(pingTreeTargetId) {
      pingTreeTargetService.duplicateTarget(accountsService.currentAccountId, pingTreeTargetId)
        .then(function (response) {
          const pingTreeTarget = response.target;
          const isRtbRttResponse = response.isRtbRTTResponse;
          vm.isRtbRTTResponse = isRtbRttResponse;
          vm.currentPingTreeTarget = pingTreeTargetService.formatParsers(pingTreeTarget);
        })
        .catch(utils.errorHandler);
    }

  }
})();
